import axios from "axios";
import { PagedResult } from "../models/paged-result";
import { Practica } from "../models/practica";
import { PracticaCreate } from "../models/practica-create";
import { PracticaEdit } from "../models/practica-edit";
import { PracticaEnviarRechazar } from "../models/practica-enviar-rechazar";

export const PRACTICA_URL = `Practica`;

export const practicaServices = {
  getList: (queryParams: any) => {
    return axios.get<PagedResult>(`${PRACTICA_URL}`, { params: queryParams });
  },

  getById: (id: string) => {
    return axios.get<Practica>(`${PRACTICA_URL}/${id}`);
  },

  create: function (data: PracticaCreate[]) {
    return axios.post(PRACTICA_URL, { practicas: data });
  },

  delete: function (id: string) {
    return axios.delete(`${PRACTICA_URL}/${id}`);
  },

  download: function (ids: string[]) {
    const params = { obraSocialId: ids };
    return axios.post<any>(`${PRACTICA_URL}/exportarPracticas`, params);
  },

  getRemitos: (
    fechaDesde: string,
    profesionalId: string,
    obraSocialId: string[]
  ) => {
    const params = {
      fechaDesde: fechaDesde,
      profesionalId: profesionalId,
      obraSocialId: obraSocialId,
    };
    return axios.get<PagedResult>(`${PRACTICA_URL}/listaRemitos`, {
      params: params,
    });
  },

  edit: function (data: PracticaEdit) {
    return axios.put(`${PRACTICA_URL}/update`, data);
  },

  editByAdmin: function (data: PracticaEdit) {
    return axios.put(`${PRACTICA_URL}/updateByAdmin`, data);
  },

  Enviar: function (data: PracticaEnviarRechazar) {
    return axios.put(`${PRACTICA_URL}/enviar`, data);
  },

  Rechazar: function (data: PracticaEnviarRechazar) {
    return axios.put(`${PRACTICA_URL}/rechazar`, data);
  },

  EnviarMultiple: function (idsPracticas: string[]) {
    return axios.put(`${PRACTICA_URL}/enviarMultiple`, { ids: idsPracticas });
  },

  RechazarMultiple: function (idsPracticas: string[]) {
    return axios.put(`${PRACTICA_URL}/rechazarMultiple`, { ids: idsPracticas });
  },

  getRemitoPorObraSocial: (
    mesAno: string,
    profesionalId: string | undefined,
    obraSocialId: string | undefined
  ) => {
    const params = {
      mesAno: mesAno,
      profesionalId: profesionalId,
      obraSocialId: obraSocialId,
    };
    return axios.get<PagedResult>(`${PRACTICA_URL}/remitoPorObraSocial`, {
      params: params,
    });
  },

  generarArchivoSempre: (params: any) => {
    return axios.get<any>(`${PRACTICA_URL}/exportarSempre`, { params: params });
  },
};
